import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'

import { USER_BRANCH_QUERY } from '../../queries'

import Breadcrumb from '../../components/Breadcrumb/'
import Loader from '../../components/Loader/'
import Members from '../../containers/Members/'
import Error from '../../components/Error/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { Container } from '../../styles/defaults'

class CompanyMembers extends Component {
  render() {
    return (
      <Query query={USER_BRANCH_QUERY}>
        {({ loading, error, data }) => {
          if (loading) return <Loader fixed from="25%" to="100%" />
          if (error) return <Error error="de bedrijfsgegevens" />
          const { branches, permissions, role } = data.self
          const id = data.self.id
          const company = data.self.branches[0].name
          const viewUsers = (permissions.includes('VIEW_USERS') || role === 'MANAGER') && !this.props.branch.suspended

          return (
            <Fragment>
              <Breadcrumb title="Medewerkers" fill="true" />

              {viewUsers ? (
                <Members permissions={permissions} role={role} company={company} branches={branches} branch={this.props.branch} currentUser={id} />
              ) : (
                <Container style={{ textAlign: 'center' }} mt mb>
                  Onvoldoende rechten om de medewerkers te bekijken
                </Container>
              )}
            </Fragment>
          )
        }}
      </Query>
    )
  }
}

export default withHeaderFooter(CompanyMembers, '', 'black')



// WEBPACK FOOTER //
// ./src/views/CompanyMembers/index.js